import { useEffect, useRef } from "react";

export const useIdleTrigger = ({ enabled, timeout, triggerChat }) => {
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    let idleTimeoutRef;

    const resetTimer = () => {
      clearTimeout(idleTimeoutRef);
      idleTimeoutRef = setTimeout(() => {
        if (hasTriggered.current) return;
        hasTriggered.current = true;
        triggerChat("Idle");
      }, timeout * 1000);
    };

    const activityEvents = ["mousemove", "keydown", "scroll", "click"];
    activityEvents.forEach((e) => document.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      activityEvents.forEach((e) =>
        document.removeEventListener(e, resetTimer),
      );
      clearTimeout(idleTimeoutRef);
    };
  }, [enabled, timeout, triggerChat]);
};
